<div class="svg" [innerHtml]="svg$ | async"></div>
